import { render, staticRenderFns } from "./book_video.vue?vue&type=template&id=9c871a06&scoped=true&"
import script from "./book_video.vue?vue&type=script&lang=js&"
export * from "./book_video.vue?vue&type=script&lang=js&"
import style0 from "./book_video.vue?vue&type=style&index=0&id=9c871a06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c871a06",
  null
  
)

export default component.exports